import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import ExtraMileHeader from '../../components/ExtraMileHeader/ExtraMileHeader';
import { loginUser, logout } from '../../store/authSlice';
import { setBackButtonUrl } from '../../store/uiSlice';
import useDesktopBg from '../../hooks/useDesktopBg';
import './login.css';

function safeRedirectUrl(url) {
  const fallback =
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '/') ||
    '/';
  if (!url || typeof url !== 'string') return fallback;
  try {
    return new URL(url, window.location.origin).href;
  } catch {
    return fallback;
  }
}

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { status, user, error } = useSelector((s) => s.auth);
  const bg = useDesktopBg('/img/background-mob.jpg', '/img/background-web.jpg');

  useEffect(() => {
    const otp = searchParams.get('otp');
    const demo = searchParams.get('demo');
    if (otp || demo) {
      dispatch(logout());
    }
    dispatch(loginUser());
  }, [dispatch, searchParams]);

  useEffect(() => {
    if (status === 'succeeded' && user?.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user, dispatch]);

  useEffect(() => {
    if (status !== 'failed') return;
    const msg = error ? String(error) : 'Session expired';
    const redirect = safeRedirectUrl(user?.backButtonRedirect);
    const title =
      msg.includes('OTP is required') || msg.includes('No saved user')
        ? 'Login required'
        : 'Session Expired!';
    Swal.fire({
      title,
      text: msg,
      icon: 'error',
      confirmButtonText: 'Close',
      customClass: {
        confirmButton: 'hf-swal-close',
        popup: 'hf-swal-popup',
      },
      buttonsStyling: false,
    }).then(() => {
      window.location.href = redirect;
    });
  }, [status, error, user]);

  const shell = (body) => (
    <div className="login-shell bg-games" style={{ '--page-bg': `url(${bg})` }}>
      <ExtraMileHeader />
      <div className="login-page">{body}</div>
    </div>
  );

  if (status === 'loading' || status === 'idle') {
    return shell(<div className="login-loader" />);
  }

  if (status === 'succeeded' && user) {
    return shell(
      <>
        <img src="/img/welcome-logo.gif" alt="Harvest Festival" className="login-logo" />
        <button type="button" className="login-start" onClick={() => navigate('/hub')}>
          BEGIN PLAY
        </button>
      </>
    );
  }

  return shell(<div className="login-loader" />);
}
